import { ChartArea } from 'chart.js';
import { Palette } from '@infoods/lifebase-ui';

type DrawLabelOptions = {
  label: string;
  pointX: number;
  gapFromChartArea: number;
};

export const drawLabel = (
  ctx: CanvasRenderingContext2D,
  chartArea: ChartArea,
  options: DrawLabelOptions,
  palette: Palette,
) => {
  const { left, right, bottom } = chartArea;
  const { label, pointX, gapFromChartArea } = options;

  const textWidth = ctx.measureText(label).width;
  const rectPadding = 4;
  const rectHeight = 22;

  const labelY = bottom + gapFromChartArea;
  let labelX = pointX;

  ctx.save();

  if (pointX - textWidth / 2 < left) {
    labelX = left;
  } else if (pointX + textWidth / 2 > right) {
    labelX = right - textWidth;
  } else {
    labelX = pointX - textWidth / 2;
  }

  ctx.fillStyle = palette.white;
  ctx.fillRect(
    labelX - rectPadding,
    labelY - rectHeight / 2,
    textWidth + rectPadding * 2,
    rectHeight,
  );

  ctx.textBaseline = 'middle';
  ctx.textAlign = 'left';
  ctx.fillStyle = palette.mainBlack;
  ctx.fillText(label, labelX, labelY);

  ctx.restore();
};
